import * as React from 'react';
import { useEffect } from 'react';
import hoistoryStore from "../store/historyStore";
import * as util from "../utils/util";
import { exercise } from "../utils/exercise";

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CircularProgress from "@mui/material/CircularProgress";

import AddTaskIcon from '@mui/icons-material/AddTask';
import api from "../utils/api";
import { useLocation, useNavigate } from "react-router-dom";
import { notifyApiError } from "../utils/apiError";

export default function HistorySportsInput(props: any) {
  const storeData: any = hoistoryStore();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { targetDate, targetDayValue } = state ?? {};

  const [exerciseList, setExerciseList] = React.useState([{}]);
  const [searchText, setSearchText] = React.useState('');
  const [showLoading, setShowLoading] = React.useState(false);
  const [selectedExerciseInfo, setSelectedExerciseInfo] = React.useState({});
  const [memberWeight, setMemberWeight] = React.useState(0);


  useEffect(() => {
    api.get('permission/getProfile').then((res: any) => {
      setMemberWeight(res.data.weight);
    }).catch(function (error: any) {
      console.log(error)
    });
    setExerciseList(exercise);

    return () => {
    };
  }, [memberWeight]);

  // 운동 검색
  function handleSearchExercise() {
    setShowLoading(true);
    if (searchText !== '') {
      setExerciseList(exerciseList.filter((v: any) => v.type.includes(searchText)));
    } else {
      setExerciseList(exercise);
    }
    setShowLoading(false);
  }

  // 검색한 운동 목록 중 선택
  function handleSelectExercise(type: any, mets: any) {
    let selectedExercise = exercise.filter((v: any) => v.type === type);
    setSelectedExerciseInfo(selectedExercise);
    let tempExercise = { type: type, mets: Number(mets), calory: Number(mets), time: 10 };

    let exerciseArr = [];
    if (storeData.selectedExerciseList.some((item: any) => item.type === type)) {  // 이미 선택된 운동
      exerciseArr = storeData.selectedExerciseList.map((v: any) => v.type === type ? { ...v, time: Number(v.time) + 10 } : v);
    } else {  // 처음 선택된 운동
      exerciseArr = storeData.selectedExerciseList.concat(tempExercise);
    }

    // 사용자가 추가한 운동이 최상단에 위차하여 사용자가 확인할 수 있도록 순서 변경
    const newExerciseArr = [
      ...exerciseArr.filter((v: any) => v.type === type),
      ...exerciseArr.filter((v: any) => v.type !== type)
    ];

    storeData.setSelectedExerciseList(newExerciseArr);
  }

  // 선택한 운동 목록 중 선택 해제
  function handleUnselectExercise(type: any) {
    let exerciseArr = [];
    if (storeData.selectedExerciseList.some((item: any) => item.type === type && item.time > 10)) {  // 해제한 운동의 카운트가 10 초과일 때 => 푸드 객체 count - 10
      exerciseArr = storeData.selectedExerciseList.map((v: any) => v.type === type ? { ...v, time: Number(v.time) - 10 } : v);
    } else {  // 해제한 운동의 카운트가 10 일 때 => 배열에서 운동 객체 삭제
      exerciseArr = storeData.selectedExerciseList.filter((v: any) => !(v.type === type));
    }
    storeData.setSelectedExerciseList(exerciseArr);
  }

  // 선택한 운동 목록 중 시간 추가
  function handleAddselectExercise(type: any) {
    let exerciseArr = [];
    if (storeData.selectedExerciseList.some((item: any) => item.type)) {  // 해제한 운동의 카운트가 10 초과일 때 => 푸드 객체 count - 10
      exerciseArr = storeData.selectedExerciseList.map((v: any) => v.type === type ? { ...v, time: Number(v.time) + 10 } : v);
    }
    storeData.setSelectedExerciseList(exerciseArr);
  }

  // 운동 저장
  async function handleComplete(value: any) {
    if (util.strNull(window.localStorage.userCusID) !== '') {
      let saveParams = { date: '', calory: '', type: '', time: '' };
      saveParams.date = targetDate.slice(0, 4) + '-' + targetDate.slice(4, 6) + '-' + targetDate.slice(6, 8);
      saveParams.type = storeData.selectedExerciseList.map((v: any) => v.type).join('--');
      saveParams.time = storeData.selectedExerciseList.map((v: any) => v.time).join('--');
      saveParams.calory = storeData.selectedExerciseList.map((v: any) => util.getCaloryByMets(v.time / 60, v.mets, memberWeight)).join('--');

      api.post(`app/api/v1/AP_002_007`, saveParams).then(res => {
        storeData.setSelectedExerciseList([]);
        navigate('/history/burn', { state: { targetDateBack: targetDate, targetDayValue: targetDayValue } });
      }).catch(function (error) {
        // 저장 실패를 알리지 않으면 사용자는 기록이 남은 줄 안다
        notifyApiError(error, '운동 기록을 저장하지 못했습니다.');
      });
    }
  }

  function handleClose() {
    navigate('/history/burn', { state: { targetDateBack: targetDate, targetDayValue: targetDayValue } });
  }



  return (
    <React.Fragment>
      <Stack sx={{ width: '100%', minWidth: 320, height: '100%', background: '#fff', pb: 10, px: 2, pt: 2, boxSizing: 'border-box' }} spacing={6}>
        <Stack>
          <Typography
            sx={{
              color: '#333',
              fontSize: 18,
              fontWeight: 700,
              textAlign: 'center',
              mb: '20px',
              borderBottom: '1px solid #ddd',
              pb: 2
            }}
          >
            오늘의 운동을 입력하세요
          </Typography>

          <Box sx={{ border: '1px solid #ccc', borderRadius: '15px', width: '100%' }}>

            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ bgcolor: '#f5f5f5', pt: 0.5, pb: 0.5, pr: 1, borderRadius: '15px 15px 0 0', }}>
              <InputBase
                sx={search_Fome_Style}
                placeholder="운동명을 입력하세요"
                inputProps={{ 'aria-label': '운동명을 입력하세요' }}
                onChange={(e) => setSearchText(e.target.value)}
                value={searchText}
                type="search"
              />
              <Box sx={{ width: '30%', bgcolor: '#EF8322', color: '#fff', borderRadius: 5, textAlign: 'center', py: .5, boxSizing: 'border-box' }} aria-label="search" onClick={handleSearchExercise}>
                <SearchIcon sx={{ verticalAlign: 'middle', }} /> <Typography component={'span'} sx={{ fontSize: 15 }}>검색</Typography>
              </Box>
            </Stack>

            <Box sx={{ display: showLoading ? 'flex' : 'none', justifyContent: 'center', alignContent: 'center', p: 1 }}>
              <CircularProgress color="secondary" />
            </Box>
            <Box>
              <List sx={{ p: 2, maxHeight: 250, overflow: 'auto', borderTop: '1px solid #ccc', }}>
                {!showLoading && exerciseList.map((item: any, index: any) => (
                  <ListItem sx={{ mb: 1, border: '1px solid #ccc', p: 0.5, borderRadius: 3, pl: 2, pr: 1 }} onClick={() => handleSelectExercise(item.type, item.mets)}
                    secondaryAction={
                      <IconButton aria-label="add" edge="end" onClick={() => handleSelectExercise(item.type, item.mets)}>
                        <AddTaskIcon sx={{ color: '#EF8322' }} />
                      </IconButton>
                    }
                  >

                    <ListItemText>
                      <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{item.type} </Typography>
                      <Typography sx={{ fontSize: 14, }}>{item.mets * 60} kcal / 60분 </Typography>
                    </ListItemText>
                  </ListItem>
                ))}
              </List>
            </Box>
            <Box sx={{
              borderTop: '1px solid #ccc',
              maxHeight: 300, overflow: 'auto', bgcolor: '#f5f5f5', borderRadius: '0 0 15px 15px', p: 1,
            }}>

              {storeData.selectedExerciseList.filter((item: any) => item.type !== '').map((item: any, index: any) => (
                <Box sx={{ p: 1, pt: 0.5, pb: 0.5 }}>
                  <Stack direction='row' justifyContent={'center'} alignItems={'center'} sx={{ bgcolor: '#fff', borderRadius: 2, p: 1, border: '1px solid #ddd' }}>
                    <Typography component={'div'} sx={{ fontSize: 14, fontWeight: 700, width: '30%', textAlign: 'center' }}>
                      {item.type}
                    </Typography>

                    <Typography component={'div'} sx={{ fontSize: 14, width: '20%', textAlign: 'center' }}>
                      {item.time}분
                    </Typography>

                    <Typography component={'div'} sx={{ fontSize: 14, fontWeight: 700, width: '30%', textAlign: 'center' }}>
                      {util.formatComma(util.getCaloryByMets(item.time / 60, item.mets, memberWeight))}
                      <Typography component={'span'} sx={{ fontSize: 14, fontWeight: 300, }}> kcal</Typography>
                    </Typography>

                    <IconButton aria-label="add" onClick={() => handleAddselectExercise(item.type)} sx={{ width: '10%', textAlign: 'center', mr: 1.5 }}>
                      <AddCircleOutlineIcon sx={{ color: '#5d86ff', fontSize: 30 }} />
                    </IconButton>
                    <IconButton aria-label="remove" onClick={() => handleUnselectExercise(item.type)} sx={{ width: '10%', textAlign: 'center' }}>
                      <RemoveCircleOutlineIcon sx={{ color: '#f54d4d', fontSize: 30 }} />
                    </IconButton>
                  </Stack>
                </Box>
              ))}

            </Box>

          </Box>



        </Stack>
      </Stack>



      <Stack direction={'row'} spacing={2} sx={{ position: 'fixed', bottom: 0, px: 2, width: '100%', boxSizing: 'border-box', bgcolor: '#f5f5f5', py: 1.5 }}>
        <EditButton onClick={handleClose} sx={{ width: '90%' }}>
          취소
        </EditButton>
        <EditButton onClick={handleComplete} sx={{ width: '90%', backgroundColor: '#EF8322', color: '#fff' }}>
          저장
        </EditButton>
      </Stack>
    </React.Fragment>
  );
}

const search_Fome_Style = {
  px: 2,
  py: .5,
  m: 1,
  bgcolor: '#fff',
  borderRadius: '24px',
  boxShadow: 'inset 0 0 4px rgba(0,0,0,0.4)',
  boxSizing: 'border-box'
};

const EditButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '6px 20px',
  lineHeight: 1.5,
  backgroundColor: '#fff',
  border: '1px solid #EF8322',
  borderRadius: '20px',
  color: '#EF8322',
  margin: '10px 0 30px 0',
  width: '90%',

  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});
